/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { DimensionEnum } from "./DimensionEnum";
import {
  DimensionEnumFromJSON,
  DimensionEnumFromJSONTyped,
  DimensionEnumToJSON,
  DimensionEnumToJSONTyped,
} from "./DimensionEnum";
import type { BoundaryConditionTypeEnum } from "./BoundaryConditionTypeEnum";
import {
  BoundaryConditionTypeEnumFromJSON,
  BoundaryConditionTypeEnumFromJSONTyped,
  BoundaryConditionTypeEnumToJSON,
  BoundaryConditionTypeEnumToJSONTyped,
} from "./BoundaryConditionTypeEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PatchedBoundaryCondition
 */
export interface PatchedBoundaryCondition {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  boundaryId?: number;
  /**
   *
   */
  readonly threedimodel?: string;
  /**
   *
   */
  type?: BoundaryConditionTypeEnum;
  /**
   *
   */
  dimension?: DimensionEnum;
}

/**
 * Check if a given object implements the PatchedBoundaryCondition interface.
 */
export function instanceOfPatchedBoundaryCondition(
  value: object
): value is PatchedBoundaryCondition {
  return true;
}

export function PatchedBoundaryConditionFromJSON(json: any): PatchedBoundaryCondition {
  return PatchedBoundaryConditionFromJSONTyped(json, false);
}

export function PatchedBoundaryConditionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PatchedBoundaryCondition {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    url: json["url"] == null ? undefined : json["url"],
    boundaryId: json["boundary_id"] == null ? undefined : json["boundary_id"],
    threedimodel: json["threedimodel"] == null ? undefined : json["threedimodel"],
    type: json["type"] == null ? undefined : BoundaryConditionTypeEnumFromJSON(json["type"]),
    dimension: json["dimension"] == null ? undefined : DimensionEnumFromJSON(json["dimension"]),
  };
}

export function PatchedBoundaryConditionToJSON(json: any): PatchedBoundaryCondition {
  return PatchedBoundaryConditionToJSONTyped(json, false);
}

export function PatchedBoundaryConditionToJSONTyped(
  value?: Omit<PatchedBoundaryCondition, "id" | "url" | "threedimodel"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    boundary_id: value["boundaryId"],
    type: BoundaryConditionTypeEnumToJSON(value["type"]),
    dimension: DimensionEnumToJSON(value["dimension"]),
  };
}
